<div class="card">
  <!-- <h4><strong>Goods Receipt Line Item</strong></h4> -->
  <div class="card" style="display: flex; justify-content: space-between; align-items: center; padding: 0; border: none; background-color: transparent;">
    <div>
        <h4><strong style=" margin-left: 10px;">Goods Receipt Line Item</strong></h4>
    </div>
    <div style="display: flex; margin-top: -10px;">
        <button pButton type="button" icon="pi pi-download" (click)="downloadExcel()" style=" background-color: #2c436b;" label="Excel Report"></button>
        <!-- <button pButton type="button" icon="pi pi-download" (click)="downloadPDF()" style="height: 10px; margin-right: 10px; background-color: #2c436b;" label="PDF Report"></button> -->
    </div>
</div>
  <hr>
  <p-treeTable #tt [value]="mappedData" styleClass="p-treetable-gridlines" [columns]="cols"
       [scrollable]="true"[tableStyle]="{ 'min-width': '250rem','min-height':'10px' }">
      <ng-template pTemplate="header" let-columns>
          <tr>
              <!-- <th style="width: 4rem;text-align: center; white-space: nowrap;">Action</th> -->
              <th>Vendor Code</th>
              <th>Status</th>
              <th>Invoice No</th>
              <th>Invoice Date</th>
              <th>PO/Agreement No</th>
              <th>GR No</th>
              <th>GR Date</th>
              <th>Gate Entry No</th>
              <th>Gate Entry Date</th>
              <th>Vendor Name</th>
              <th>Plant</th>
              <th>Line Item No</th>
              <th>Material Code</th>
              <th>Description</th>
              <th>UOM</th>
              <th>Storage Location</th>
              <th>GR Batch No</th>
              <th>GR Quantity</th>
              <th>Gate Entry Quantity</th>
              <th>OK Quantity</th>
              <th>Reject Quantity</th>
          </tr>
          <!-- <tr>
              <th *ngFor="let col of cols">
                  <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)"
                      [ngModel]="col.defaultFilter" />
              </th>
          </tr> -->
          <tr>
            <th *ngFor="let col of cols">
                <!-- <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)"
                    [ngModel]="col.defaultFilter" /> -->
                    <ng-container *ngIf="col.field === 'gate_entry_date' || col.field === 'gr_date' || col.field === 'invoice_date'; else textInput">
                      <input pInputText type="date" (change)="onInputChange($event, col.field)" placeholder="Select date..." />
                    </ng-container>
                    <ng-template #textInput>
                      <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)" />
                    </ng-template>
            </th>
        </tr>
      </ng-template>
      <!-- <ng-template pTemplate="caption">
          <div class="flex justify-content-end align-items-center">
              <div class="p-input-icon-left">
                  <i class="pi pi-search" style="font-size: 12px;"></i>
                  <input type="text" class="global-search" pInputText placeholder="Global Search"
                      (input)="onGlobalSearch($event)" />
              </div>
          </div>
      </ng-template> -->
      <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
          <tr [ttRow]="rowNode">
              <td *ngFor="let col of columns; let i = index; let last = last">
                  <div class="row">
                      <!-- <div class="column">
                          <p-button *ngIf="i === 0 && rowNode.node.children && rowNode.node.children.length > 0"
                              tooltipPosition="top" icon="pi pi-eye" (click)="onClickGr(rowNode)" [rounded]="true"
                              [style]="{ 'margin-right': '.5em' }"></p-button> -->
                          <!-- <p-treeTableToggler [rowNode]="rowNode" *ngIf="i === 0"></p-treeTableToggler> -->
                      <!-- </div> -->
                      <!-- <div>
                          {{ rowData[col.field] }}
                      </div> -->
                      <div *ngIf="col.field === 'status'; else defaultField">
                          <span class="custom-tag" [ngClass]="getSeverityClass(getSeverity(rowData[col.field]))">
                              {{ rowData[col.field] }}
                          </span>
                      </div>

                      <ng-template #defaultField>
                          {{ rowData[col.field] }}
                      </ng-template>
                  </div>
              </td>
          </tr>
      </ng-template>
  </p-treeTable>
  <div>
    <p-paginator
    [rows]="limit"
    [first]="(currentPage - 1) * limit"
    [totalRecords]="totalRecords"
    (onPageChange)="onPageChange($event)"
    [rowsPerPageOptions]="[10, 20,30,50,100]"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      />
</div>
</div>
<div *ngIf="isLoading" class="loading-overlay">
  <app-loading-screen></app-loading-screen>
</div>
